@if (point.pointResult) {
  <div>
    @if (!point.pointResult.fieldValue) {
      <app-detail-result-button
        (resultChange)="onPointResultChanged()"
        [result]="point.pointResult"
        [isFkp]="point.isFkp"
        [defectDescriptionSuggestions]="point.defectDescriptionSuggestions"
        [readonly]="readonly"
        [elementName]="point.pointName"></app-detail-result-button>
    }
    @if (point.pointResult.fieldValue) {
      <form #form="ngForm" (focusout)="!form.invalid && onPointFieldValueChanged()">
        @if (point.pointResult.fieldValue.inspectionElementFieldType === fieldTypes.Text) {
          <form-control>
            <input
              name="textValue"
              [(ngModel)]="point.pointResult.fieldValue.textValue"
              type="text"
              maxlength="255"
              [disabled]="readonly || point.isTextReadonly"
              [title]="point.pointResult.fieldValue.textValue" />
            @if (!isTextFieldValueSuggestionEmpty()) {
              <select
                name="dropdownTextFieldValueSuggestions"
                [disabled]="readonly"
                class="form-select select-only"
                (change)="insertTextFieldValueSuggestion($event.target.value)">
                @for (
                  textFieldValueSuggestion of getTextFieldValueSuggestions(
                    point.pointResult.fieldValue.textValue
                  );
                  track textFieldValueSuggestion
                ) {
                  <option [ngValue]="textFieldValueSuggestion">
                    {{ textFieldValueSuggestion }}
                  </option>
                }
              </select>
            }
          </form-control>
        }
        @if (point.pointResult.fieldValue.inspectionElementFieldType === fieldTypes.Number) {
          <form-control invalidKey="InvalidNumber">
            <input
              name="numberValue"
              [(ngModel)]="point.pointResult.fieldValue.numberValue"
              type="number"
              [disabled]="readonly" />
            @if (!readonly && displayCopyFieldValueNumber) {
              <div
                ngbPopover="{{ 'Wert kopieren' | translate }}"
                placement="bottom"
                triggers="mouseenter:mouseleave">
                <button
                  class="btn btn-outline-primary ms-1"
                  (click)="onCopyFieldValueNumber()"
                  [appDisable]="readonly">
                  <span class="far fa-copy"></span>
                </button>
              </div>
            }
          </form-control>
        }
        @if (point.pointResult.fieldValue.inspectionElementFieldType === fieldTypes.YesNo) {
          <form-control>
            <select
              name="yesNoValue"
              [(ngModel)]="point.pointResult.fieldValue.yesNoValue"
              [disabled]="readonly"
              class="form-select">
              <option [ngValue]="null"></option>
              <option [ngValue]="true" translate>Ja</option>
              <option [ngValue]="false" translate>Nein</option>
            </select>
          </form-control>
        }
        @if (point.pointResult.fieldValue.inspectionElementFieldType === fieldTypes.Date) {
          <form-control>
            <app-mkde-datepicker
              name="dateValue"
              [(ngModel)]="point.pointResult.fieldValue.dateValue"
              [disabled]="readonly"></app-mkde-datepicker>
          </form-control>
        }
      </form>
    }
  </div>
}
